export function useCalculateDifferenceStep({ minStep, maxStep, startPrice, isPercent }) {
  let min
  let max

  if (isPercent) {
    const percentageFormula = (step) => startPrice - (startPrice * step) / 100
    min = percentageFormula(maxStep)
    if ((startPrice * minStep) / 100 < 0.01) max = startPrice - 0.01
    else {
      max = percentageFormula(minStep)
    }
  } else {
    min = startPrice - maxStep
    max = startPrice - minStep
  }

  return {
    min: Number.isInteger(min) ? min : min.toFixed(2),
    max: Number.isInteger(max) ? max : max.toFixed(2),
  }
}
